var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame52(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#4B0082"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3125 25.8574H12.6875C11.7538 25.8574 11 25.0916 11 24.1431V13.8574C11 12.9088 11.7538 12.1431 12.6875 12.1431H27.3125C28.2463 12.1431 29 12.9088 29 13.8574V24.1431C29 25.0916 28.2463 25.8574 27.3125 25.8574ZM12.6875 13.2859C12.3725 13.2859 12.125 13.5374 12.125 13.8574V24.1431C12.125 24.4631 12.3725 24.7145 12.6875 24.7145H27.3125C27.6275 24.7145 27.875 24.4631 27.875 24.1431V13.8574C27.875 13.5374 27.6275 13.2859 27.3125 13.2859H12.6875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 21.2401C19.2124 21.2401 18.4924 20.9201 17.9524 20.3372L12.0461 13.9601C11.8324 13.7315 11.8436 13.3658 12.0686 13.1486C12.2936 12.9315 12.6536 12.9429 12.8674 13.1715L18.7736 19.5486C19.4149 20.2458 20.5849 20.2458 21.2261 19.5486L27.1324 13.1829C27.3461 12.9544 27.7061 12.9429 27.9311 13.1601C28.1561 13.3772 28.1674 13.7429 27.9536 13.9715L22.0474 20.3486C21.5074 20.9315 20.7874 21.2515 19.9999 21.2515V21.2401Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame52);
export default __webpack_public_path__ + "static/media/Frame 52.42533b73d6ba4cd929a2142a1116f19f.svg";
export { ForwardRef as ReactComponent };